












































































import Vue from 'vue';
export default Vue.extend({
  data (): Record<string, any> {
    return {
      valid: false,
      nickname: '',
      email: '',
      address: '',
      rules: {
        required: (v: string) => !!v || '해당 칸을 입력해주세요.',
        nickname: (v: string) => (v.length >= 2 && v.length <= 10) || '닉네임은 2~10자로 설정해주세요.',
        email: (v: string) => /.+@.+/.test(v) || '이메일 형식에 맞게 작성해주세요.',
        // address: 
      }
    }
  },
  methods: {
    submit () {
      console.log('submit')
    },
    jusoPopup () {
      console.log('juso popup')
      // const pop = window.open("./juso.jsp","pop","width=570,height=420, scrollbars=yes, resizable=yes");
      window.open("./juso.jsp","pop","width=570,height=420, scrollbars=yes, resizable=yes");
    },
    goToMain () {
      this.$router.push('/')
    }
  }
})
